import { Record } from 'immutable'

export const SET_COMPANY = 'SET_COMPANY'
export const SET_QUESTION = 'SET_QUESTION'
export const PAYMENT_METHOD = {
  CARD: 2,
  POSTPAY: 5,
}

/**
 * Reducer section
 */
const initialState = {
  paymentMethod: PAYMENT_METHOD.POSTPAY,
  payments: {
    results: [],
  },
  employees: {
    results: [],
  },
  questions: {
    results: [],
  },
  userErrors: [],
}

const Company = new Record(initialState)

// FlowType
type Action = {
  type: string,
  payload: {
    company: Company,
  },
}

// FlowType
type Action = {
  type: string,
  payload: {},
}

export function reducer(state: Record = initialState, action: Action) {
  switch (action.type) {
    case SET_COMPANY:
      return Object.assign({}, state, action.payload)
    case SET_QUESTION:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export function setCompany(payload: Company) {
  return {
    type: SET_COMPANY,
    payload,
  }
}

export function setQuestions(payload: Company.questions) {
  return {
    type: SET_QUESTION,
    payload,
  }
}
